/**
 * @typedef {'PHOENIX_COURT' | 'SOLAR'| 'LOCAL_GLOBE' | 'LATITUDE' | 'BASECAMP' | 'PHOENIX_COURT_WORKS'} Branding
 * @typedef {{
 *      siteName: string;
 *      fundSlug: string;
 *      fundPages: Array<{slug: string;}>;
 *      quickLinks: Array<{
 *          label: string;
 *          link: Object;
 *      }>;
 *      footerLinks: Array<{
 *          label: string;
 *          link: Object;
 *      }>;
 *      peopleListingNavigation: Array<{
 *          page: Object;
 *      }>;
 *      branding: Branding;
 * }} SiteContextObject
 */

/**
 * @type {SiteContextObject}
 */
let SITE_CONTEXT = {};

/**
 * Set global site context
 * @param {SiteContextObject} d
 */
export const setSiteContext = (d) => {
    SITE_CONTEXT = {
        siteName: 'Phoenix Court',
        branding: 'PHOENIX_COURT',
        ...d
    };
};

/**
 * Get global site context
 * @return {SiteContextObject}
 */
export const getSiteContext = () => {
    // new URL or something
    return SITE_CONTEXT;
};

/**
 * @param {Branding} branding
 * @returns {Record<'colour1'|'colour2'|'colour3'|'colour4', number[]>}
 */
export const getBackgroundColours = (branding = getSiteContext().branding) => {
    let colour1 = null;
    let colour2 = null;
    let colour3 = null;
    let colour4 = null;

    switch (branding) {
    case 'SOLAR':
        colour1 = [228, 228, 228];
        colour2 = [237, 115, 172];
        colour3 = [252, 211, 22];
        colour4 = [237, 115, 172];
        break;
    case 'LOCAL_GLOBE':
        colour1 = [228, 228, 228];
        colour2 = [255, 214, 77];
        colour3 = [66, 185, 255];
        colour4 = [84, 158, 139];
        break;
    case 'LATITUDE':
        colour1 = [228, 228, 228];
        colour2 = [255, 227, 49];
        colour3 = [87, 167, 38];
        colour4 = [157, 200, 131];
        break;
    case 'BASECAMP':
        colour1 = [228, 228, 228];
        colour2 = [238, 83, 82];
        colour3 = [237, 115, 172];
        colour4 = [252, 211, 22];
        break;
    case 'PHOENIX_COURT_WORKS':
        colour1 = [228, 228, 228];
        colour2 = [96, 36, 130];
        colour3 = [254, 220, 5];
        colour4 = [242, 213, 128];
        break;
    case 'PHOENIX_COURT':
    default:
        colour1 = [228, 228, 228];
        colour2 = [239, 97, 128];
        colour3 = [237, 95, 168];
        colour4 = [251, 195, 126];
        break;
    }

    return {
        colour1,
        colour2,
        colour3,
        colour4
    };
};
